
import { Box, Typography, createTheme, Stack } from "@mui/material";
import React, {useMemo, useState} from "react";
import { useAppSettings } from "../../contexts/app-context/AppContext";
import { isMobile, isTablet } from 'react-device-detect';
import { useConfigurationsContext } from "../../contexts/configurations-context/UseConfigurationsContext";
import { useOfflineDetectContext } from "../../contexts/offline-detect-context/UseOfflineDetectContext";
import ContextConfigurationSelect from "./ContextConfigurationSelect";
import { SideSheetGroupedSelectOptionGroup } from "../side-sheet/side-sheet-grouped-select/SideSheetGroupedSelect";

export function ContextConfigurationPicker() {
    const [filterText, setFilterText] = useState('');
    const {
        configurationsContextState, 
    } = useConfigurationsContext();
    
    const isPhone = isMobile && !isTablet;
    const [appSettings] = useAppSettings();
    const [offlineState] = useOfflineDetectContext();
    
    // const theme = useMemo(() => {
    //         return isPhone ? createTheme(appSettings.themeSet[appSettings.themeSet.mode].appHeaderV2) :
    //             createTheme(appSettings.themeSet[appSettings.themeSet.mode].main);
    // }, [
    //     appSettings.themeSet,
    //     isPhone
    // ]);


    const hideFilter = (configurationsContextState.configurations?.some(o => o.options.length > 0) ?? false) ? false : true;

    const configurations = useMemo(() => {

        const filter = filterText.trim().toLowerCase();

        return configurationsContextState.configurations?.map(o => {
            return {
                heading: o.heading,
                options: o.options.filter(v => v.value === configurationsContextState.configurationID ||
                                             filter.length === 0 ||  v.label.toLowerCase().includes(filter))                
            } as SideSheetGroupedSelectOptionGroup<number>;
        }) ?? [];
    },
    [
        filterText,
        configurationsContextState.configurations,
        configurationsContextState.configurationID
    ]);

    return (
        <Stack
            direction='row'
            sx={{
                alignItems: 'flex-end',
                marginLeft: 'auto'
            }}>
            <Stack direction='column'
                sx={{
                    overflow: 'hidden',
                }}
            >
            <Typography 
                variant="caption"
                sx={{
                    //color: theme => isPhone ? 'inherit' : theme.palette.grey[600],
                    opacity: 0.7,
                    alignSelf: (configurationsContextState.configurations ?? []).length > 0 ? 'undefined' : 'flex-end'
                }}
            >
                Page Settings
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    flex: '1 1 auto',
                    justifyContent: 'flex-end',
                    marginBottom: 'auto',
                    marginRight: 'auto',
                    alignItems: 'center',
                    paddingBottom: '2px',
                }}
            >

                {
                !offlineState.offline &&
                <ContextConfigurationSelect 
                    hideFilter={hideFilter}
                    filterText={filterText}
                    setFilterText={setFilterText}
                    //optionGroups={configurationsContextState.configurations ?? []} 
                    optionGroups={configurations} 
                    configurationID={configurationsContextState.configurationID ?? -1}/>
                }
            </Box>
            </Stack>
        </Stack>
    );
}



